export default __webpack_public_path__ + "static/media/vehicle-desktop.7fb1c7b5.svg";